import React from "react";
import Paper from "@mui/material/Paper";
import BulkPriceChangeAffectedProductsTable
    from "../../../../../../../../components/app-specific/bulk-price-change-affected-products-table";
import DateUtils from "../../../../../../../../../core/services/date-utils";

const dataGridSaveConfig = {
    name: "BulkPriceChangeReviewAndFinalizeSectionDataGrid",
    version: 1,
}

const BulkPriceChangeReviewAndFinalizeSection = ({
                                                     selectedItemIds,
                                                     requestId,
                                                     priceLevels,
                                                     operatorName,
                                                     submitDate,
                                                 }) => {

    return (
        <>
            <div className={'d-flex flex-column w-100'}>
                <Paper
                    className={'paper content review-and-finalize-section d-flex flex-column align-items-start w-100 px-3'}
                    style={{borderRadius: '0 0 5px 5px'}}
                >
                    <div className={'d-flex flex-wrap justify-content-center w-100'}>
                        <div className={'bubble-card'}>
                            <p>
                                {DateUtils.serverToLocal(submitDate).format(DateUtils.dateTimeFormat)}
                            </p>
                        </div>
                        <div className={'bubble-card mx-4'}>
                            <p>
                                {operatorName ?? ''}
                            </p>
                        </div>
                    </div>
                    <p className={'text-md font-weight-semi-bold mb-3 mt-5'}>
                        {`Affected Price Levels (${priceLevels.length})`}
                    </p>
                    <div className={'d-flex flex-wrap w-100'}>
                        {
                            priceLevels.map(priceLevel => (
                                <div className={'bubble-card'} key={priceLevel.id}>
                                    <p>
                                        {priceLevel.title ?? ''}
                                    </p>
                                </div>
                            ))
                        }
                    </div>
                </Paper>
                <div className={'mb-5'}/>
                {
                    !!selectedItemIds?.length &&
                    <BulkPriceChangeAffectedProductsTable
                        selectedItemIds={selectedItemIds}
                        requestId={requestId}
                        saveConfig={dataGridSaveConfig}
                    />
                }
            </div>
        </>
    )
}

export default BulkPriceChangeReviewAndFinalizeSection;
